/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBankTransfer = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11.5 7V6h2v1H16v2h-2.5v2h.75c1.64 0 2.75 1.473 2.75 3s-1.11 3-2.75 3h-.75v1h-2v-1H9v-2h2.5v-2h-.75C9.11 13 8 11.527 8 10s1.11-3 2.75-3zm0 2h-.75c-.293 0-.75.318-.75 1 0 .682.457 1 .75 1h.75zm2 4v2h.75c.293 0 .75-.318.75-1s-.457-1-.75-1zM9.071 6.036H4.414l1.829 1.828-1.414 1.414L.586 5.036 4.829.793l1.414 1.414-1.829 1.829h4.657zm5.929 14h4.657l-1.828 1.828 1.414 1.414 4.242-4.242-4.242-4.243-1.414 1.414 1.828 1.829H15z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgBankTransfer as BankTransfer };
